import * as angular from "angular";

const events = {
  services: {
    display: 'maps-services-display',
    selected: 'maps-service-selected',
    removeSelected: 'maps-service-remove-selected',
    selectedIds: 'list-service-selectedIds',
    byOrder: 'display-services-by-order',
    clearByOrder: 'clear-services-by-order'
  },
  itinerary: {
    draw: 'draw-itinerary',
    refresh: 'refresh-itinerary',
    hide: 'hide-itinerary',
    selectMarker: 'set-marker-animation'
  },
  itineraryMap: {
    drawAssigned: 'itinerary-draw-assigned',
    drawCompleted: 'itinerary-draw-completed'
  },
  agents: {
    displayAll: 'display-all-agents',
    select: 'agent-marker-clicked',
    hide: 'hide-all-agents'
  },
  siteMarket: {
    displayDeliveryTaskMarkers: 'display-markers',
    markersBounce: 'markers-bounce',
    taskMarkersBounce: 'task-markers-bounce',
    stopAllMarkersBounce: 'stop-all-markers-bounce',
    suggestedMarkersBounce: 'suggested-markers-bounce',
    displaySuggestedMarkers: 'display-suggested-markers',
    removeSuggestedMarkers: 'remove-suggested-markers',
    removeDeliveryTaskMarkers: 'remove-delivery-task-markers',
    resizeMap: 'resize-map'
  },
  doCenter: 'center-bringoz-map'
};

angular
  .module('bringoz.admin.map')
  .constant('mapConstant', {
    events: events,
    ready: 'maps-loaded-successfully'
  });
